import { render, staticRenderFns } from "./Sponsorship.vue?vue&type=template&id=9fe8cd66&scoped=true&"
import script from "./Sponsorship.vue?vue&type=script&lang=js&"
export * from "./Sponsorship.vue?vue&type=script&lang=js&"
import style0 from "./Sponsorship.vue?vue&type=style&index=0&id=9fe8cd66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe8cd66",
  null
  
)

export default component.exports